import ParameterErrors from '../errors/ParameterErrors';
import Vector2 from '../geometry/Vector2';
import Location from '../modelling/Location';
import UrlHelper from '../core/UrlHelper';
import PlotStatus from './PlotStatus';
import HouseTypes from './HouseTypes';
import RoomType from './RoomType';
import eventEnable from '../core/eventEnable';
import Handles from '../core/Handles';
import enableAcceptBindings from '../mvvm/enableAcceptBindings';
import exposeBinding from '../mvvm/exposeBinding';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJsonUnitBirdsEyeView{
	constructor(props){
		const {index, markerPosition}=props;
		if(index===undefined||index===null)
			throwNotProvided('index');
		
		if(typeof(index)!=='number')
			throwNotOfType('index', 'number');
		this._index = index;
		
		if(markerPosition===undefined || markerPosition===null)
			throwNotProvided('markerPosition');
		this._markerPosition = markerPosition;
	}
	get index(){
	    return this._index;
	}
	get markerPosition(){
		return this._markerPosition;
	}
	toJSON(){
		throw new Error('Not implemented');
	}
	static fromJSON(jObject){
		return new SiteJsonUnitBirdsEyeView({
			index:jObject.index, 
			markerPosition:jObject.markerPosition?Vector2.fromObj(jObject.markerPosition):null
		});
	}
	
}